import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BulkSiteUploadTypeSelection } from './enums';
import { BulkSiteUploadOptionsSelectionModel } from './models';

@Injectable({
    providedIn: 'root'
})
export class BulkSiteUploadOptionsSelectionLogicService {

    model: BulkSiteUploadOptionsSelectionModel = new BulkSiteUploadOptionsSelectionModel();

    constructor() { }

    initModel(): void {
        this.model = new BulkSiteUploadOptionsSelectionModel();
        this.createTypeSelectionForm();
    }

    createTypeSelectionForm(): void {
        this.model.typeSelectionForm = new UntypedFormGroup({
            bulkSiteUploadType: new UntypedFormControl(BulkSiteUploadTypeSelection.Excel, [Validators.required]),
        });
    }

    setApplySiteTemplate(value: boolean): void {
        this.model.applySiteTemplate = value;
    }

    setSelectedSiteTemplateId(value: string): void {
        this.model.selectedSiteTemplateId = value;
    }
}
